import { useState } from 'react';

// item 685 (Chad) — a personal, persisted "auto-collapse sections" preference (localStorage, per
// browser — same pattern as the Appearance skin + the proposal step auto-collapse). When ON, opening
// a section collapses the others (single-open). Default ON; an explicit OFF ('0') is remembered.
const KEY = 'basix.autoCollapse';

export default function useAutoCollapse(defaultOn = true): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState<boolean>(() => {
    try {
      const s = localStorage.getItem(KEY);
      return s === null ? defaultOn : s === '1';
    } catch {
      return defaultOn;
    }
  });
  const set = (next: boolean): void => {
    setOn(next);
    try { localStorage.setItem(KEY, next ? '1' : '0'); } catch { /* private mode — ignore */ }
  };
  return [on, set];
}
